import { render, staticRenderFns } from "./product_1_fkw.vue?vue&type=template&id=31c18658&scoped=true"
import script from "./product_1_fkw.vue?vue&type=script&lang=js"
export * from "./product_1_fkw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c18658",
  null
  
)

export default component.exports